import {inject, injectable} from 'inversify';

import type {Expand} from '../../../../api/types';
import type {UserExpandFieldsCommon} from '../../../../api/user';

import {userExpandCommon} from '../../../../api/user';
import {extendExpand} from '../../../../api/utils/expand';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class UserExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = userExpandCommon;
    const core: Expand = base;
    const b2b: Expand = extendExpand(base, [['population_ids']]);

    return this.resolve({b2b, core, key});
  }
}

export namespace UserExpandJrpc {
  export type ExpandedFields = UserExpandFieldsCommon;
}
